// Import model
import { UpdateObjectTaskRequest } from '../models/UpdateObjectTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateObjectTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateObjectTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateObjectTaskRequest instance
   */
  static deserialize(json: string): UpdateObjectTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateObjectTaskRequest instance
   */
  static fromObject(obj: any): UpdateObjectTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateObjectTaskRequest');
    }


    const instance: UpdateObjectTaskRequest = {
      dueDate: obj['dueDate'] as string | undefined,
      priority: obj['priority'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      content: obj['content'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateObjectTaskRequest instances
   */
  static deserializeArray(json: string): UpdateObjectTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateObjectTaskRequest instance to a JSON string
   */
  static serialize(instance: UpdateObjectTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateObjectTaskRequest instance to a plain object
   */
  static toObject(instance: UpdateObjectTaskRequest): any {
    return {
      'dueDate': instance.dueDate,
      'priority': instance.priority,
      'name': instance.name,
      'description': instance.description,
      'content': instance.content,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of UpdateObjectTaskRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateObjectTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
